// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "6c0279586fdad77e8dde888e44264dec57134261/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"21":"36bf3700","98":"aa14b4c2","130":"e0aa582e","440":"486bdddc","581":"a474c96c","731":"5ac47554","822":"5ed7a9db"}[chunkId] + ".chunk.js";
};